// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.9.0_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.9.0_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html:root {
  --adm-color-primary: #00d39a;
  --adm-color-background: #f8f8f8;
}
html[data-prefers-color-scheme=dark] {
  --adm-color-primary: #20232a;
  --adm-color-text: #686c6f;
}
html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
}
a {
  color: inherit;
  text-decoration: none;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
#root {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  background: var(--adm-color-background);
}
.header {
  text-align: center;
}
#main {
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
#content {
  flex: 1;
  overflow-y: auto;
}
.adm-nav-bar {
  background: var(--adm-color-primary);
  color: #fff;
}
.adm-tab-bar {
  background: #fff;
}
.adm-popover-inner {
  background: var(--adm-color-primary) !important;
  color: #fff;
}
.loading {
  line-height: 0.26rem;
  font-size: 0.14rem;
  color: #999;
}
`, "",{"version":3,"sources":["webpack://./src/main.less"],"names":[],"mappings":"AAAA;EACI,4BAAA;EACA,+BAAA;AACJ;AAEA;EACI,4BAAA;EAKA,yBAAA;AAJJ;AAaA;;EAEI,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,8IAAA;AAXJ;AAeA;EACI,cAAA;EACA,qBAAA;AAbJ;AAgBA;EACI,sBAAA;EACA,SAAA;EACA,UAAA;AAdJ;AAiBA;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EAEA,uCAAA;AAhBJ;AAmBA;EACI,kBAAA;AAjBJ;AAoBA;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAlBJ;AAqBA;EACI,OAAA;EACA,gBAAA;AAnBJ;AAuBA;EACI,oCAAA;EACA,WAAA;AArBJ;AAwBA;EACI,gBAAA;AAtBJ;AAyBA;EACI,+CAAA;EACA,WAAA;AAvBJ;AA0BA;EACI,oBAAA;EACA,kBAAA;EACA,WAAA;AAxBJ","sourcesContent":["html:root {\n    --adm-color-primary: #00d39a;\n    --adm-color-background: #f8f8f8;\n}\n\nhtml[data-prefers-color-scheme=dark] {\n    --adm-color-primary: #20232a;\n    // --adm-color-success: #00b578;\n    // --adm-color-warning: #ff8f1f;\n    // --adm-color-danger: #ff3141;\n    // --adm-color-white: #ffffff;\n    --adm-color-text: #686c6f;\n    // --adm-color-text-secondary: #666666;\n    // --adm-color-weak: #999999;\n    // --adm-color-light: #cccccc;\n    // --adm-color-border: #eeeeee;\n    // --adm-color-box: #f5f5f5;\n    // --adm-color-background: #ffffff;\n}\n\nhtml,\nbody {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    background: #fff;\n    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,\n        Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n}\n\na {\n    color: inherit;\n    text-decoration: none;\n}\n\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\n#root {\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    // background: #f8f8f8;\n    background: var(--adm-color-background);\n}\n\n.header {\n    text-align: center;\n}\n\n#main {\n    flex-grow: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n#content {\n    flex: 1;\n    overflow-y: auto;\n\n}\n\n.adm-nav-bar {\n    background: var(--adm-color-primary);\n    color: #fff;\n}\n\n.adm-tab-bar {\n    background: #fff;\n}\n\n.adm-popover-inner {\n    background: var(--adm-color-primary) !important;\n    color: #fff;\n}\n\n.loading {\n    line-height: 26px;\n    font-size: 14px;\n    color: #999;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
